// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"002aa88a","453":"5a0ff4c5","667":"74e44067"}[chunkId] + ".chunk.js";
};